// modules/clientes/services/clienteService.js
import axios from "../../../config/axiosConfig";

const BASE = "/api/clientes";

// ── CLIENTES ──────────────────────────────────────────────────
export const getAll      = (params)           => axios.get(BASE, { params });
export const getById     = (cod_cliente)      => axios.get(`${BASE}/${cod_cliente}`);
export const create      = (data)             => axios.post(BASE, data);
export const update      = (cod_cliente, data) => axios.put(`${BASE}/${cod_cliente}`, data);
export const getCatalogos = ()                => axios.get(`${BASE}/catalogos`);

// CONTACTOS PRINCIPALES DEL CLIENTE
export const getContactos = (cod_cliente) =>
  axios.get(`${BASE}/${cod_cliente}/contactos`);
export const getContactoById = (cod_cliente, id_contacto) =>
  axios.get(`${BASE}/${cod_cliente}/contactos/${id_contacto}`);
export const createContacto = (cod_cliente, data) =>
  axios.post(`${BASE}/${cod_cliente}/contactos`, data);
export const updateContacto = (cod_cliente, id_contacto, data) =>
  axios.put(`${BASE}/${cod_cliente}/contactos/${id_contacto}`, data);
export const deleteContacto = (cod_cliente, id_contacto) =>
  axios.delete(`${BASE}/${cod_cliente}/contactos/${id_contacto}`);

// ── SERVICIOS DEL CLIENTE (listado rápido) ────────────────────
export const getServiciosResumen = (cod_cliente) =>
  axios.get("/api/cliente-servicio", { params: { codCliente: cod_cliente } });

// ── SERVICIOS ─────────────────────────────────────────────────
export const getServicios     = (cod_cliente)                        => axios.get(`${BASE}/${cod_cliente}/servicios`);
export const getServicioById  = (cod_cliente, cod_servicio_cliente)  => axios.get(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}`);
export const createServicio   = (cod_cliente, data)                  => axios.post(`${BASE}/${cod_cliente}/servicios`, data);
export const updateServicio   = (cod_cliente, cod_servicio_cliente, data) => axios.put(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}`, data);
export const cambiarClienteServicio = (cod_cliente, cod_servicio_cliente, data) =>
  axios.put(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/cambiar-cliente`, data);
export const getHistorialServicio = (cod_cliente, cod_servicio_cliente) =>
  axios.get(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/historial`);

// ── CONTACTOS DEL SERVICIO ─────────────────────────────────────
export const getContactosServicio = (cod_cliente, cod_servicio_cliente) =>
  axios.get(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/contactos`);
export const createContactoServicio = (cod_cliente, cod_servicio_cliente, data) =>
  axios.post(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/contactos`, data);
export const updateContactoServicio = (cod_cliente, cod_servicio_cliente, id_contacto, data) =>
  axios.put(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/contactos/${id_contacto}`, data);

// ── INFORMACIÓN DE FACTURACIÓN DEL SERVICIO ────────────────────
export const getLegalServicio = (cod_cliente, cod_servicio_cliente) =>
  axios.get(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/legal`);
export const getLegalServicioById = (cod_cliente, cod_servicio_cliente, id_legal) =>
  axios.get(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/legal/${id_legal}`);
export const createLegalServicio = (cod_cliente, cod_servicio_cliente, data) =>
  axios.post(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/legal`, data);
export const updateLegalServicio = (cod_cliente, cod_servicio_cliente, id_legal, data) =>
  axios.put(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/legal/${id_legal}`, data);

// ── INFORMACIÓN LEGAL ─────────────────────────────────────────
// CONTRATOS DEL SERVICIO
export const getContratosServicio = (cod_cliente, cod_servicio_cliente) =>
  axios.get(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/contratos`);
export const getContratoServicioById = (cod_cliente, cod_servicio_cliente, id_contrato) =>
  axios.get(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/contratos/${id_contrato}`);
export const createContratoServicio = (cod_cliente, cod_servicio_cliente, data) =>
  axios.post(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/contratos`, data);
export const updateContratoServicio = (cod_cliente, cod_servicio_cliente, id_contrato, data) =>
  axios.put(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/contratos/${id_contrato}`, data);
export const deleteContratoServicio = (cod_cliente, cod_servicio_cliente, id_contrato) =>
  axios.delete(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/contratos/${id_contrato}`);

// ── ARCHIVOS DE CONTRATO DEL SERVICIO ──────────────────────────
export const getContratoArchivos = (cod_cliente, cod_servicio_cliente) =>
  axios.get(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/contrato-archivos`);
export const uploadContratoArchivos = (cod_cliente, cod_servicio_cliente, files) => {
  const formData = new FormData();
  Array.from(files).forEach((file) => formData.append("archivos", file));
  return axios.post(
    `${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/contrato-archivos`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
};
export const deleteContratoArchivo = (cod_cliente, cod_servicio_cliente, id) =>
  axios.delete(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/contrato-archivos/${id}`);

export const getLegal     = (cod_cliente)              => axios.get(`${BASE}/${cod_cliente}/legal`);
export const getLegalById = (cod_cliente, id_legal)    => axios.get(`${BASE}/${cod_cliente}/legal/${id_legal}`);
export const createLegal  = (cod_cliente, data)        => axios.post(`${BASE}/${cod_cliente}/legal`, data);
export const updateLegal  = (cod_cliente, id_legal, data) => axios.put(`${BASE}/${cod_cliente}/legal/${id_legal}`, data);

// ── IMÁGENES DEL SERVICIO ──────────────────────────────────────
export const getImagenesServicio = (cod_cliente, cod_servicio_cliente) =>
  axios.get(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/imagenes`);
export const uploadImagenesServicio = (cod_cliente, cod_servicio_cliente, files) => {
  const formData = new FormData();
  Array.from(files).forEach((file) => formData.append("imagenes", file));
  return axios.post(
    `${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/imagenes`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
};
export const setImagenPrincipalServicio = (cod_cliente, cod_servicio_cliente, id) =>
  axios.put(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/imagenes/${id}/principal`);
export const deleteImagenServicio = (cod_cliente, cod_servicio_cliente, id) =>
  axios.delete(`${BASE}/${cod_cliente}/servicios/${cod_servicio_cliente}/imagenes/${id}`);
